export default __webpack_public_path__ + "static/talentos-axur-venha-com-a-gente-fazer-da-internet-um-lugar-mais-seguro-391ca37b4343b52aac04fabd7fc2e18f.jpg";